"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSmallTag = exports.StyledTag = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const getTagBGandColor = (variant) => {
    switch (variant) {
        case 'normal':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.primary.light};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'lightGray':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.grayScale[200]};
        p {
          color: ${theme_1.palette.grayScale[600]};
        }
      `;
        case 'darkGray':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.grayScale[600]};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'red':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.system.error};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'green':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.system.badge};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'lightBlue':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.system.info};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'darkGreen':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.system.success};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'darkerGray':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.primary.darker};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'orange':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.system.warning};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'darkBlue':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.primary.main};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
        case 'inverted':
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.text.inverted};
        p {
          color: ${theme_1.palette.primary.main};
        }
      `;
        default:
            return (0, styled_components_1.css) `
        background-color: ${theme_1.palette.primary.dark};
        p {
          color: ${theme_1.palette.text.inverted};
        }
      `;
    }
};
exports.StyledTag = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ variant = 'darkBlue', customStyles }) => {
    return (0, styled_components_1.css) `
      padding: 2px 12px;
      gap: 8px;
      border-radius: 12px;
      text-transform: uppercase;
      ${getTagBGandColor(variant)}
      ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}
    `;
}}
`;
exports.StyledSmallTag = (0, styled_components_1.default)(exports.StyledTag) `
  padding: 0 8px;
  border-radius: 24px;
  min-width: 32px;
`;
//# sourceMappingURL=styles.js.map